<ul class="header-btn-group d-flex align-items-center">
   <li >
      <a class="icon-primary-btn d-flex" href="javascript:void(0)">
         <mat-search-bar #searchApiKey class="mat-search-bar" (onClose)="onSearch('')"
            (keydown.enter)="onSearch(searchApiKey.value)" id="searchApiKey">
         </mat-search-bar>
      </a>
   </li>
   <li >
      <button class="icon-primary-btn btn-primary float-right" type="button" (click)="requestGenerateApiKeyModal()">
         GENERATE API KEY
      </button>
   </li>
   <li>
      <app-help-section [helpSectionData]="helpsection">
      </app-help-section>
   </li>
</ul>


<!--bootstrap modal window for remove custom api key -->
<ng-template #addCustomApi let-c="close" let-d="dismiss">
   <div class="modal-header">
      <h4 class="modal-title d-flex justify-content-between">Generate API key
         <button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
         </button>
      </h4>
   </div>
   <div class="modal-body">
      <form [formGroup]="frmCreateEditApiKey">
         <mat-form-field class="w-575px mb-3">
            <input matInput placeholder="API key name" formControlName="apikeyname">
         </mat-form-field>

         <mat-radio-group formControlName="apipermission" class="mat-custom-radio-button mb-3" ngDefaultControl>
            <h4 class="font-medium api-header">API permission</h4>
            
            <mat-radio-button [checked]="checkAllPermission" name="apipermission" value = "1" (change)="onRadioChangeEvent($event)"
               class="mr-3 "><span class="option">All</span></mat-radio-button>
            <mat-radio-button name="apipermission" [checked]="(+this.savingdata.per === 2)" value = "2"
               (change)="onRadioChangeEvent($event)"><span class="option">Select</span></mat-radio-button>
         </mat-radio-group>
         <div class="row mb-3 mt-3" *ngIf="showPermissionSelect">
            <div class="col-4" *ngFor="let item of apilist">
               <mat-checkbox class="mat-custom-check-box option" [checked]="item.selected"
                  (change)="onPermissionCheckboxClick( $event.source.checked, item.id)" value="{{item.id}}">
                  {{item.label}}
               </mat-checkbox>
            </div>
            <small class="form-text text-danger"
               *ngIf="!frmCreateEditApiKey.controls['apipermission'].valid && frmCreateEditApiKey.controls['apipermission'].touched">
               Field required.
            </small>

         </div>
         <mat-form-field class="w-575px mt-2">
            <input matInput name="allowedips" id="allowedips"
               placeholder="10.0.0.1, 10.0.0/2"
               formControlName="allowedips">
         </mat-form-field>
      </form>
   </div>
   <div class="modal-footer">
      <button class="btn btn-primary text-uppercase" [disabled]="true" *ngIf="frmCreateEditApiKey.invalid && !editApiKey">Generate</button>
      <button class="btn btn-primary text-uppercase" *ngIf="frmCreateEditApiKey.valid && !editApiKey"
         (click)="createAPIKey(frmCreateEditApiKey.value,1)"> Generate</button>
      <button class="btn btn-primary text-uppercase" [disabled]="true" *ngIf="frmCreateEditApiKey.invalid && editApiKey">Update API
         Key</button>
      <button class="btn btn-primary text-uppercase" *ngIf="frmCreateEditApiKey.valid && editApiKey"
         (click)="createAPIKey(frmCreateEditApiKey.value,2)"> Update API Key</button>
      <button class="btn btn-secondary text-uppercase" (click)="cancelCreationApiKey()">Cancel</button>
   </div>
</ng-template>